import {Dispatch} from 'react';
import {AuthLogout, UpdateSession} from './AuthActions';
import {APP_LOGIN_URL, APP_LOGOUT_URL} from '../config/getEnvironmentVars';
import {Buffer} from 'buffer';
import OktaAuth, {SessionObject} from '@okta/okta-auth-js';
import {v4 as uuidV4} from 'uuid';
import {AuthProps} from './AuthReducer';

export const SessionStates = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  MFA_REQUIRED: 'MFA_REQUIRED',
  MFA_ENROLL: 'MFA_ENROLL',
};

const handleRedirect = async (authClient: OktaAuth) => {
  try {
    await authClient.handleRedirect();
  } catch (e) {
    // log or display error details
    console.log(e);
  }
};

const generateToken = (authClient: OktaAuth) => {
  //@ts-ignore
  const queryParams = globalThis.location.search;
  const params = new URLSearchParams(queryParams);

  authClient.token.getWithRedirect({
    state: Buffer.from(
      JSON.stringify({...Object.fromEntries(params.entries()), uuid: uuidV4()}),
    ).toString('base64'),
  });
};

export const authLogout = async (
  dispatch: Dispatch<any>,
  authClient: OktaAuth,
  logoutURL = APP_LOGOUT_URL,
) => {
  await authClient.signOut({
    postLogoutRedirectUri: logoutURL,
  });
  AuthLogout(dispatch);
};

export const authLogin = async (
  dispatch: Dispatch<any>,
  state: AuthProps,
  authClient: OktaAuth,
) => {
  const session =
    state.session !== undefined && Object.keys(state.session).length > 1
      ? state.session
      : await getSession(authClient, (session: SessionObject) =>
          UpdateSession(dispatch, session),
        );
  const sessionExists = isSessionActive(session);
  const isAuthenticated = await authClient.isAuthenticated();

  if (!sessionExists) {
    if (authClient.isLoginRedirect()) {
      handleRedirect(authClient);
  
    } else if (isAuthenticated) {
      // User is authenticated
      authLogout(dispatch, authClient);
  
    } else {
      // User is NOT authenticated
      await authClient.signInWithRedirect({
        authorizeUrl: APP_LOGIN_URL,
      });
    }
  
  } else if (!isAuthenticated && sessionExists) {
    generateToken(authClient);
  }
  
};
export const refreshSession = (
  dispatch: Dispatch<any>,
  authClient: OktaAuth,
) => {
  authClient.session
    .refresh()
    .then((session) => {
      UpdateSession(dispatch, session as SessionObject);
    })
    .catch((err) => console.warn(err));
};

export const refreshToken = (authClient: OktaAuth) => {
  authClient.token
    .renewTokens()
    .then((newToken) => {
      authClient.tokenManager.setTokens(newToken);
    })
    .catch((error) => {
      console.warn(error);
    });
};

export const getSession = async (authClient: OktaAuth, updateSessionState) => {
  const session = await authClient.session.get();
  updateSessionState(session);
  return session;
};

export const isSessionActive = (session: SessionObject | undefined) => {
  return session?.status === SessionStates.ACTIVE;
};

export const isTokenValid = async (
  state: AuthProps,
  authClient: OktaAuth,
  dispatch: Dispatch<any>,
) => {
  try {
    const session =
      state.session !== undefined && Object.keys(state.session).length > 1
        ? state.session
        : await getSession(authClient, (session: SessionObject) =>
            UpdateSession(dispatch, session),
          );
    const sessionUser: any = await session?.user?.();

    if (
      state.user?.preferred_username &&
      sessionUser?.profile?.login &&
      state.user?.preferred_username !== sessionUser?.profile?.login
    ) {
      //user1 user2 & user@oa.com user2@oa.com
      //user1 user2 & user@oa.com user@oa.com
      authClient.tokenManager.clear();
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      location.reload();
    }
  } catch (error) {
    //invalid session
    console.log(error);
  }
};
